import { render, staticRenderFns } from "./TLocationStaticIp.vue?vue&type=template&id=214a9462&"
import script from "./TLocationStaticIp.vue?vue&type=script&lang=js&"
export * from "./TLocationStaticIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports